import { render, staticRenderFns } from "./PayPalButton.vue?vue&type=template&id=5dad86ee&"
import script from "./PayPalButton.vue?vue&type=script&lang=js&"
export * from "./PayPalButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports